import type { ActionsObservable } from 'redux-observable';
import type { AjaxError } from 'rxjs';
import type { Epic } from '@helpcenter/epics-rxjs';
import { Observable } from '@helpcenter/epics-rxjs';

import type { HandleAjaxError } from '@helpcenter/flags';
import { handleAjaxError } from '@helpcenter/flags';
import { forgotPassword } from 'rest/login';
import type { ForgotPassword, ForgotPasswordSuccess } from 'state/actions/login';
import { FORGOT_PASSWORD, forgotPasswordSuccess } from 'state/actions/login';

export const forgotPasswordEpic: Epic<ForgotPassword, ForgotPasswordSuccess | HandleAjaxError> = (
    action$: ActionsObservable<ForgotPassword>
) => {
    return action$.ofType(FORGOT_PASSWORD).mergeMap((forgotPasswordAction) => {
        const { resetUrl, email } = forgotPasswordAction.payload;
        return forgotPassword(resetUrl, email)
            .map(() => {
                return forgotPasswordSuccess();
            })
            .catch((error: AjaxError) => {
                return Observable.of(handleAjaxError(error));
            });
    });
};
